import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../../app/routes";
import Payments from "./Payments";
import Info from "./Info";
import Invoices from "./Invoices";

export default function Index({ teamId, memberId }) {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [currentCycle, setCurrentCycle] = useState(undefined);

  const [withoutCycles, setWithoutCycles] = useState(false);

  const updateCollection = () => {
    setLoaded(true);
    axios
      .get(routes.api.cycles.list(teamId), {
        params: { memberId: memberId },
      })
      .then((resp) => {
        let cycle = resp.data.data.find(
          (item) => item.attributes.current == "Yes"
        );
        if (cycle == undefined && resp.data.data.length > 0) {
          cycle = resp.data.data[0];
        }
        setLoaded(false);
        if (cycle == undefined) {
          setWithoutCycles(true);
        } else {
          setCurrentCycle(cycle);

          setCollection(resp.data.data);
        }
      });
  };

  const setCycle = (value) => {
    let cycle = collection.find((item) => item.id == value.value);
    setCurrentCycle(null);
    setCurrentCycle(cycle);
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      {loaded && <p className="text-center mt20">Processing...</p>}

      {!loaded && (
        <>
          {withoutCycles && (
            <p className="text-center mt20">
              You do not have enrollment cycles
            </p>
          )}
          {!withoutCycles && (
            <>
              <Info
                collection={collection}
                cycle={currentCycle}
                memberId={memberId}
                setCycle={setCycle}
              />
              <Payments cycle={currentCycle} memberId={memberId} />

              <Invoices />
            </>
          )}
        </>
      )}
    </>
  );
}
